import api from 'src/lib/api/client';
import ApiError from 'src/lib/api/error';

const ModelService = {
  async searchModels({ params }) {
    try {
      const client = await api.getClient();
      return client.searchModels(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getModel({ id }) {
    try {
      const client = await api.getClient();
      return client.viewModel({ id });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createModel({ model }) {
    try {
      const client = await api.getClient();
      return client.createModel(null, model);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateModel({ id, model }) {
    try {
      const client = await api.getClient();

      client.interceptors.response.use((response) => response, (error) => {
        // Redirect after update
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return client.updateModel(id, model);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default ModelService;
